import { appConfig, headerConfig, refineHeader } from '../../config'

export const postupService = { addPostup, listPostup, getPostupDetail, editPostup }

function addPostup(postData, url) {
  refineHeader()
  const requestOptions = {
    method: 'POST',
    headers: headerConfig.headerImage,
    mode: 'cors',
    body: postData,
  }

  return fetch(`${appConfig.api.url}${url}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data
    })
}

function editPostup(postData, url) {
  refineHeader()
  const requestOptions = {
    method: 'POST',
    headers: headerConfig.headerImage,
    mode: 'cors',
    body: postData,
  }

  return fetch(`${appConfig.api.url}${url}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data
    })
}

function listPostup(postData, url="postup-list/list") {
  refineHeader()
  const requestOptions = {
    method: 'POST',
    headers: headerConfig.headerDatas,
    mode: 'cors',
    body: JSON.stringify(postData),
  }

  return fetch(`${appConfig.api.url}${url}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data
    })
}

function getPostupDetail(postupID, url) {
  refineHeader()
  const requestOptions = {
    method: 'GET',
    headers: headerConfig.headerDatas,
    mode: 'cors',
  }

  return fetch(`${appConfig.api.url}${url}/${postupID}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data
    })
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }

    return data
  })
}


// WEBPACK FOOTER //
// ./src/app/services/API/postupService.js